<template>
  <footer class="mt-12 pb-6 border-t border-slate-800 pt-6 text-center">
    <div class="flex flex-wrap justify-center items-center gap-x-5 gap-y-3 text-xs text-slate-400 px-4">
      
      <NuxtLink :to="localePath('/about')" class="hover:text-white hover:underline transition-colors duration-200">
        {{ locale === 'zh' ? '关于我们' : 'About Us' }}
      </NuxtLink>

      <NuxtLink :to="localePath('/faq')" class="hover:text-white hover:underline transition-colors duration-200">
        {{ locale === 'zh' ? '常见问题' : 'FAQ' }}
      </NuxtLink>

      <NuxtLink :to="localePath('/disclaimer')" class="hover:text-white hover:underline transition-colors duration-200">
        {{ locale === 'zh' ? '免责声明' : 'Disclaimer' }}
      </NuxtLink>

      <NuxtLink :to="localePath('/privacy')" class="hover:text-white hover:underline transition-colors duration-200">
        {{ locale === 'zh' ? '隐私政策' : 'Privacy Policy' }}
      </NuxtLink>
    </div>

    <div class="mt-6 pt-5 border-t border-slate-800/50 flex flex-col items-center justify-center space-y-2">
      <span class="text-[10px] text-slate-600 font-bold tracking-[0.2em] uppercase">
        {{ locale === 'zh' ? '探索更多精彩' : 'Discover More' }}
      </span>
      <a 
        href="https://vibejb.com" 
        target="_blank" 
        rel="noopener noreferrer" 
        class="group flex items-center gap-2 text-[13px] font-bold text-slate-400 hover:text-orange-400 transition-all duration-300"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="group-hover:animate-bounce">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0Z"></path><circle cx="12" cy="10" r="3"></circle>
        </svg>
        <span class="border-b border-transparent group-hover:border-orange-400/50 pb-0.5">
          {{ locale === 'zh' ? 'VibeJB - 新山旅游、民宿与夜生活指南' : 'VibeJB - JB Travel & Nightlife Guide' }}
        </span>
      </a>
    </div>

    <div class="mt-6 text-[10px] text-slate-700 tracking-wider">
      &copy; {{ new Date().getFullYear() }} Lottobox Live. All rights reserved.
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()

// 🚀 新增核心利器：路径智能转换引擎
const localePath = useLocalePath()
</script>
